/**
 * Internal dependencies
 */
import BlockSlider from "./block-slider";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockSliderManager {

	/**
	 * Public vars
	 */

	/**
	 * @type Document
	 */
	contextDocument = document;

	/**
	 * @type Array
	 */
	blockSliderList = [];

	/**
	 * @type String
	 */
	blockSliderSelector = '.block-slider';

	/**
	 * @type Array
	 */
	customSliderList = [];

	/**
	 * @type String
	 */
	customSliderBaseClass = 'custom-slider';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		this.contextDocument.addEventListener( 'WMUViewportChange', this.onViewportChange );

		this.onArchiveItemsAdded = this.onArchiveItemsAdded.bind( this );
		window.addEventListener( 'wmuwpblocks/archive/itemsAdded', this.onArchiveItemsAdded );
	}

	/**
	 * 
	 */
	clear()
	{
		/**
		 * Block sliders
		 */
		this.blockSliderList.forEach( ( slider ) =>
		{
			slider.clear();
		} );

		this.blockSliderList = [];

		/**
		 * Custom sliders
		 */
		this.customSliderList.forEach( ( slider ) =>
		{
			slider.clear();
		} );

		this.customSliderList = [];
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setup( contextElement = null )
	{
		/**
		 * @type String
		 */
		const viewportCurrent = ViewportManager.getCurrentViewport();

		if ( null === contextElement )
		{
			contextElement = this.contextDocument;
		}

		/**
		 * Block sliders
		 */
		contextElement.querySelectorAll( this.blockSliderSelector ).forEach( ( sliderElement ) =>
		{
			if ( ! sliderElement.wmuBlockSlider )
			{
				const slider = new BlockSlider( sliderElement );
				slider.setup();
				this.blockSliderList.push( slider );
			}
		} );

		/**
		 * Custom sliders
		 */
		contextElement.querySelectorAll( `.${viewportCurrent}-${this.customSliderBaseClass}` ).forEach( ( sliderElement ) =>
		{
			if ( ! sliderElement.wmuBlockSlider )
			{
				const slider = new BlockSlider( sliderElement, {
					settingsAttributeBaseName: 'slider-settings',
					swiperSlideSelector: sliderElement.getAttribute( `${viewportCurrent}-slider-s-sel` ),
					swiperWrapperSelector: sliderElement.getAttribute( `${viewportCurrent}-slider-w-sel` ),
				} );
				slider.setup();
				this.customSliderList.push( slider );
			}
		} );

		window.dispatchEvent( new CustomEvent( 'wmuwpblocks/sliderManager/setup', {
			detail: {
				contextElement: contextElement,
				sliderManager: this,
				blockSliderList: this.blockSliderList,
			}
		} ) );
	}

	/**
	 * Event handlers
	 */

	/**
	 * 
	 * @param {Event} event 
	 */
	onArchiveItemsAdded( event )
	{
		if ( event.detail && event.detail.item && event.detail.item.length )
		{
			event.detail.item.forEach( ( item ) => this.setup( item ) );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockSliderManager;